module.exports = __webpack_public_path__ + "files/9b4e7402015df7f9e44c9fc7e1267980.png";